module.exports = __webpack_public_path__ + "static/media/donaciones-santuario.f7ecd54b.jpg";